import Joi from 'joi';
import { AxiosError } from 'axios';
import api from '../api';

/**
 * Upload file in bucket
 * @param {File} file
 * @returns {Promise<{fileUuid: string}>} - The file uuid.
 */
export const createFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const result = await api.post('/files', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  try {
    const schema = Joi.object({
      fileUuid: Joi.string().required(),
    });
    await schema.validateAsync(result.data, { allowUnknown: true });
  } catch (error) {
    throw new AxiosError('', `API response do not match file Schema : ${error.message}`);
  }
  return result.data;
};
